var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 25,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 .5h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7 21.5q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19.5v-13H4v-2h5v-1h6v1h5v2h-1v13q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21.5zm10-15H7v13h10zm-8 11h2v-9H9zm4 0h2v-9h-2z"
}))));
export { SvgDelete as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRlbGV0ZSI+CjxtYXNrIGlkPSJtYXNrMF8yNzg5XzkzNjkiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNSI+CjxyZWN0IGlkPSJCb3VuZGluZyBib3giIHk9IjAuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRkZGRkZGIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yNzg5XzkzNjkpIj4KPHBhdGggaWQ9ImRlbGV0ZV8yIiBkPSJNNyAyMS41QzYuNDUgMjEuNSA1Ljk3OTE3IDIxLjMwNDIgNS41ODc1IDIwLjkxMjVDNS4xOTU4MyAyMC41MjA4IDUgMjAuMDUgNSAxOS41VjYuNUg0VjQuNUg5VjMuNUgxNVY0LjVIMjBWNi41SDE5VjE5LjVDMTkgMjAuMDUgMTguODA0MiAyMC41MjA4IDE4LjQxMjUgMjAuOTEyNUMxOC4wMjA4IDIxLjMwNDIgMTcuNTUgMjEuNSAxNyAyMS41SDdaTTE3IDYuNUg3VjE5LjVIMTdWNi41Wk05IDE3LjVIMTFWOC41SDlWMTcuNVpNMTMgMTcuNUgxNVY4LjVIMTNWMTcuNVoiIGZpbGw9IiNGRkZGRkYiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=";